export const SET_PENDING = 'MESSAGING/SET_PENDING';
export const SET_NOTIFICATIONS_TOKENS = 'MESSAGING/NOTIFICATIONS/SET_TOKENS';
export const SET_NOTIFICATIONS_FAVORITE_TOKENS = 'MESSAGING/NOTIFICATIONS/SET_FAVORITE_TOKENS';
export const SET_NOTIFICATIONS_DATA = 'MESSAGING/NOTIFICATIONS/SET_DATA';
export const SET_NOTIFICATIONS_PENDING = 'MESSAGING/NOTIFICATIONS/SET_PENDING';
export const SET_NOTIFICATIONS_TEMPLATES = 'MESSAGING/NOTIFICATIONS/TEMPLATES';
